import { RefObject, useEffect, useRef } from "react";

const IGNORED_SELECTOR = [
  "[data-dialog-launcher]",
  "[data-radix-popper-content-wrapper]",
  "[data-sonner-toaster]",
  '[role="dialog"]',
  '[role="alertdialog"]',
].join(",");

export function useDismissOnOutsideClick(
  ref: RefObject<HTMLElement | null>,
  onDismiss: () => void,
  enabled: boolean = true,
) {
  const onDismissRef = useRef(onDismiss);
  onDismissRef.current = onDismiss;

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const handlePointerDown = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      if (!target || !ref.current || ref.current.contains(target)) {
        return;
      }
      // Selects, dropdowns, modals and toasts render in portals outside the card, so a click on
      // one of them is not a click away from the card. The launcher is excluded because it is a
      // toggle: dismissing here would let its own click reopen the card.
      if (target.closest(IGNORED_SELECTOR)) {
        return;
      }
      onDismissRef.current();
    };

    document.addEventListener("mousedown", handlePointerDown);
    return () => document.removeEventListener("mousedown", handlePointerDown);
  }, [ref, enabled]);
}
